module.exports = __webpack_public_path__ + "img/noData.7f1d4560.svg";